import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'fl-not-found',
  imports: [CardModule, ButtonModule, RouterModule],
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
  private router = inject(Router);

  goToHome = (): void => {
    this.router.navigate(['/home']);
  };

  contactSupport = (): void => {
    // Naviga alla pagina dei contatti esistente
    this.router.navigate(['/contatti']);
  };
}
